import { gql } from '@apollo/client';

const CREATE_CHECKOUT_SESSION = gql`
  query CreateCheckoutSession($createCheckoutSessionInput: CreateCheckoutSessionInput!) {
    createCheckoutSession(createCheckoutSessionInput: $createCheckoutSessionInput) {
      id
      object
      cancel_url
      client_reference_id
      client_secret
      created
      currency
      return_url
    }
  }
`;

const CREATE_BILLING_PORTAL_SESSION = gql`
  query GetCustomerPortal($coachId: String!) {
    getCustomerPortal(coachId: $coachId) {
      url
    }
  }
`;

const ENABLE_SUBSCRIPTION = gql`
  query EnableSubscription($sessionId: String!, $coachId: String!) {
    enableSubscription(sessionId: $sessionId, coachId: $coachId) {
      message
    }
  }
`;

const UNSUBSCRIBE_PLAN = gql`
  mutation UnsubscribePlan {
    unsubscribePlan {
      statusCode
      message
      success
    }
  }
`;

const ENABLE_FREE_TRIAL = gql`
  mutation ActivateFreeTrial($coachId: String!) {
    activateFreeTrial(coachId: $coachId) {
      statusCode
      message
      success
    }
  }
`;

const GET_SUBSCRIPTIONPLANS = gql`
  query getSubscriptionPlans($coachId: String!) {
    getSubscriptionPlans(coachId: $coachId) {
      subscriptionPlanStatus {
        currentPlan
        daysLeft
        paymentStatus
        nextPlan
      }
      clientLimitStatus
      subscriptionPlans {
        id
        name
        stripeProductId
        maxUserCount
        isActive
        price
        features
        rank
      }
    }
  }
`;

const ENABLE_FREE_PLAN = gql`
  mutation ActivateFreePlan($coachId: String!) {
    activateFreePlan(coachId: $coachId) {
      statusCode
      message
      success
    }
  }
`;

type TEnableFreePlanReq = {
  coachId: string;
};
type TEnableFreePlanRes = {
  activateFreePlan: {
    statusCode: number;
    message: string;
    success: boolean;
  };
};

export {
  CREATE_CHECKOUT_SESSION,
  CREATE_BILLING_PORTAL_SESSION,
  ENABLE_SUBSCRIPTION,
  UNSUBSCRIBE_PLAN,
  ENABLE_FREE_TRIAL,
  GET_SUBSCRIPTIONPLANS,
  ENABLE_FREE_PLAN,
};

export type { TEnableFreePlanReq, TEnableFreePlanRes };
